import React, { useEffect } from "react";

export const Impressum = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      Impressum
      <div>Impressum</div>
    </div>
  );
};
